import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children, allowedRole }) {
  const token = localStorage.getItem("token");
  const userRole = localStorage.getItem("userRole");

  if (!token) {
    // Not logged in? Back to sign in
    return <Navigate to="/signin" replace />;
  }

  if (allowedRole && userRole !== allowedRole) {
    // Wrong role? Send them to their correct home
    return userRole === "employer" 
      ? <Navigate to="/employer/dashboard" replace /> 
      : <Navigate to="/dashboard" replace />;
  }

  return children;
}